module.exports = __webpack_public_path__ + "static/img/apple-apple-device-design-desk-285814.9dc22001.jpg";